import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.VEHICLE_V3}/groups`;
const basePathNewGroups = API_URLS.GROUPS;

async function sendKmz(id, payload) {
	try {
		let response = await api.patch(`${basePath}/${id}/config/kmz`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.sendKmz");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.sendKmz");
		return null;
	}
}

async function sendVisit(id, payload) {
	try {
		let response = await api.patch(`${basePath}/${id}/config/visit`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.sendVisit");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.sendVisit");
		return null;
	}
}

async function sendFence(id, payload) {
	try {
		let response = await api.patch(`${basePath}/${id}/config/fence`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.sendFence");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.sendFence");
		return null;
	}
}

async function sendRiskArea(id, payload) {
	try {
		let response = await api.patch(`${basePath}/${id}/config/risk-area`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.sendRiskArea");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.sendRiskArea");
		return null;
	}
}

async function sendStreches(id, payload) {
	try {
		let response = await api.patch(`${basePath}/${id}/config/stretches`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.sendStreches");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.sendStreches");
		return null;
	}
}

async function fetchGroupsConfigs(groupId) {
	try {
		let response = await api.get(`${API_URLS.VEHICLE}/groups?groupId=${groupId}`);
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.fetchGroupsConfigs");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.fetchGroupsConfigs");
		return null;
	}
}

async function createEmailConfiguration(payload) {
	try {
		let response = await api.post(`${basePathNewGroups}/email/configuration`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.createEmailConfiguration");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.createEmailConfiguration");
		return null;
	}
}

async function fetchEmailConfiguration(groupVehicleId, codeReport) {
	try {
		const queryParams = new URLSearchParams({
			VehicleGroupId: String(groupVehicleId ?? ""),
			CodeReport: String(codeReport ?? ""),
		});
		let response = await api.get(`${basePathNewGroups}/email/configuration?${queryParams.toString()}`);
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.fetchEmailConfiguration");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.fetchEmailConfiguration");
		return null;
	}
}

async function deleteEmailConfiguration(id) {
	try {
		let response = await api.delete(`${basePathNewGroups}/email/configuration/${id}`);
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.deleteEmailConfiguration");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.deleteEmailConfiguration");
		return null;
	}
}

async function validateEmailConfiguration(keyOrPayload) {
	try {
		let key = "";
		if (typeof keyOrPayload === "string") {
			key = keyOrPayload;
		} else if (keyOrPayload && typeof keyOrPayload === "object") {
			key = keyOrPayload.key || "";
		}
		const encodedKey = encodeURIComponent((key || "").trim());
		if (!encodedKey) {
			return { error: true, message: "Chave de validação não informada." };
		}
		let response = await api.get(`${basePathNewGroups}/email/configuration/validated?key=${encodedKey}`);
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.validateEmailConfiguration");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.validateEmailConfiguration");
		return null;
	}
}

// Migrado: PATCH VEHICLE_V3/groups/{id}/config/validate-email → GET GROUPS/email/configuration/validated
async function validateEmail(groupId, keyOrPayload) {
	try {
		let key = "";
		if (typeof keyOrPayload === "string") {
			key = keyOrPayload;
		} else if (keyOrPayload && typeof keyOrPayload === "object") {
			key = keyOrPayload.key || keyOrPayload.hash || "";
		}
		const encodedKey = encodeURIComponent((key || "").trim());
		if (!encodedKey) {
			return { error: true, message: "Chave de validação não informada." };
		}
		let response = await api.get(`${basePathNewGroups}/email/configuration/validated?key=${encodedKey}`);
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.validateEmail");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.validateEmail");
		return null;
	}
}

async function fetchGroupReportsConfiguration(id) {
	try {
		let response = await api.get(`${basePathNewGroups}/reports/configuration/${id}`);
		let treated = errorHandling.handleResponse(response, "configsService.fetchGroupReportsConfiguration");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "configsService.fetchGroupReportsConfiguration");
		return null;
	}
}

export const configsService = {
	createEmailConfiguration,
	fetchEmailConfiguration,
	deleteEmailConfiguration,
	validateEmailConfiguration,
	sendKmz,
	sendFence,
	sendRiskArea,
	sendStreches,
	sendVisit,
	validateEmail,
	fetchGroupsConfigs,
	fetchGroupReportsConfiguration
};
